import { createSlice } from '@reduxjs/toolkit';
import { AppState } from '../../../store/store';
import { fetchBlogFragment, fetchListFragment } from '../actions/fragmentActions';
import { BlogFragment, ListFragment } from '../types/terrain.types';

type LoadStatus = 'loading' | 'loaded' | 'error';

interface FragmentState {
  blogs: Record<number, BlogFragment>;
  blogStatus: Record<number, LoadStatus>;
  lists: Record<number, ListFragment>;
  listStatus: Record<number, LoadStatus>;
}

const initialState: FragmentState = {
  blogs: {},
  blogStatus: {},
  lists: {},
  listStatus: {},
};

const fragmentSlice = createSlice({
  name: 'fragment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogFragment.pending, (state, action) => {
        state.blogStatus[action.meta.arg] = 'loading';
      })
      .addCase(fetchBlogFragment.fulfilled, (state, action) => {
        state.blogs[action.meta.arg] = action.payload;
        state.blogStatus[action.meta.arg] = 'loaded';
      })
      .addCase(fetchBlogFragment.rejected, (state, action) => {
        state.blogStatus[action.meta.arg] = 'error';
      })
      .addCase(fetchListFragment.pending, (state, action) => {
        state.listStatus[action.meta.arg] = 'loading';
      })
      .addCase(fetchListFragment.fulfilled, (state, action) => {
        state.lists[action.meta.arg] = action.payload;
        state.listStatus[action.meta.arg] = 'loaded';
      })
      .addCase(fetchListFragment.rejected, (state, action) => {
        state.listStatus[action.meta.arg] = 'error';
      });
  },
});

export default fragmentSlice.reducer;

export const selectBlogFragment = (id: number) => (state: AppState) =>
  state.fragments.blogs[id] ?? null;
export const selectBlogFragmentStatus = (id: number) => (state: AppState) =>
  state.fragments.blogStatus[id] ?? null;
export const selectListFragment = (id: number) => (state: AppState) =>
  state.fragments.lists[id] ?? null;
export const selectListFragmentStatus = (id: number) => (state: AppState) =>
  state.fragments.listStatus[id] ?? null;
